<h3-feedback-pane [dialogTitle]="title$ | async" (dialogClose)="closeDialog()">
  <form class="popover-body" [formGroup]="form" h3ScrollEnabler>
    <mat-form-field>
      <mat-label>Error type</mat-label>
      <mat-select formControlName="errorTag">
        <mat-option
          *ngFor="let errorTag of displayedErrorTags$ | async"
          [value]="errorTag"
          >{{ errorTag }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="shouldDisplayFrameInputs$ | async">
      <div class="frames-input">
        <mat-form-field>
          <mat-label>Start Frame</mat-label>
          <input matInput type="number" formControlName="startFrame" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>End Frame</mat-label>
          <input matInput type="number" formControlName="endFrame" />
        </mat-form-field>
      </div>
      <mat-checkbox color="primary" formControlName="allFrames">
        All frames
      </mat-checkbox>
    </ng-container>
    <mat-form-field>
      <mat-label>Comments</mat-label>
      <textarea matInput formControlName="comment"></textarea>
    </mat-form-field>
    <div class="popover-action">
      <div class="error-container">
        <mat-error
          *ngIf="
            form.hasError('invalidFrameNumber') ||
            form.controls.startFrame.invalid ||
            form.controls.endFrame.invalid
          "
          >Enter a valid frame range
        </mat-error>
      </div>
      <button
        mat-button
        type="button"
        color="primary"
        [disabled]="form.invalid"
        (click)="saveFeedback()"
      >
        SAVE
      </button>
    </div>
  </form>
</h3-feedback-pane>
